import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const card: SxStyle = {
  boxShadow: 'none',
  display: 'flex',
  flexDirection: 'row',
  gap: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(0.5),
};

export const cursor: SxStyle = {
  cursor: 'pointer',
};
